export default defineNuxtRouteMiddleware((to, from) => {
    const user = useSupabaseUser()
    const userStore = useUserStore()
    const { showErrorMessage } = useMessages()

    if (!user.value && to.path !== '/') {
        userStore.resetStore()

        showErrorMessage('Error!', 'You must be signed in to access this area.')
        return navigateTo('/')
    }
})